var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"programme-banner"},[_c('img',{attrs:{"src":_vm.url,"alt":"上太科技"}}),_c('div',{staticClass:"content-div"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }